import { CustomCellEditorProps } from "@ag-grid-community/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { SelectInstance } from "react-select";
import {
  SelectOption,
  SelectOptionProps,
} from "shared/components/input/select/SelectOption";
import { SimpleSelect } from "shared/components/input/select/SimpleSelect";
import { useMaybernTableCellEditorProps } from "shared/components/table/maybern/MaybernTableCellEditor";

export interface MaybernTableDropdownCellEditorParams {
  title: string | undefined;
  options: SelectOptionProps[];
  emptyValue: string | undefined | null;
}

export const MaybernTableDropdownCellEditor: React.FC<
  CustomCellEditorProps & MaybernTableDropdownCellEditorParams
> = ({ title, options, ...props }) => {
  const { t } = useTranslation(["common"]);
  const { inputRef, value, onValueChange, error } =
    useMaybernTableCellEditorProps<SelectInstance>(props, {
      setStartValue: ({ inputRef, startValue }) => {
        inputRef.current?.onInputChange(startValue, {
          action: "set-value",
          prevInputValue: "",
        });
      },
    });
  return (
    <SimpleSelect
      ref={inputRef}
      title={title ?? t("common:select")}
      value={value}
      onChangeValue={(value) => {
        onValueChange(value);
        props.stopEditing();
      }}
      variant="simple-table"
      openMenuOnFocus={true}
      isSearchable={true}
      error={error}
    >
      {options.map((optionProps) => (
        <SelectOption key={optionProps.value} {...optionProps} />
      ))}
    </SimpleSelect>
  );
};
